export enum FollowUpStudyInputMethod {
	SelectFromList = 1,
	WriteText = 2,
}
